/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_Rate_LimitInputs */



/**
* | output |
* | --- |
* | "The AI provider is rate limiting requests. Please wait a moment and try again." |
*
* @param {Chat_Error_Rate_LimitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_rate_limit = /** @type {((inputs?: Chat_Error_Rate_LimitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Rate_LimitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der KI-Anbieter begrenzt die Anfragen. Bitte warte einen Moment und versuche es erneut.")
	return /** @type {LocalizedString} */ ("The AI provider is rate limiting requests. Please wait a moment and try again.")
});